import { SortConfig } from '@/types/filterSearch';
import { collator } from './collator';

export const createSortConfig = <T extends object>(config: {
  textFields?: (keyof T)[];
  numberFields?: (keyof T)[];
}): SortConfig<T> => {
  // Force non-undefined returns
  const sortConfig = {} as Required<SortConfig<T>>;

  config.textFields?.forEach((field) => {
    sortConfig[field] = (a: T, b: T) =>
      collator.compare(String(a[field]), String(b[field]));
  });

  config.numberFields?.forEach((field) => {
    sortConfig[field] = (a: T, b: T) => {
      const aValue = a[field];
      const bValue = b[field];

      // Treat null/undefined as coming after all numbers
      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      return Number(aValue) - Number(bValue);
    };
  });

  return sortConfig;
};
